export default __webpack_public_path__ + "media/images/ccn-branca-13d7dba3e6879c934b7ef65af64095c7.png";